<template>
  <Modal
    :is-open="showModal"
    title="Confirme sua senha"
    size="md"
    data-testid="password-modal"
    @close="close"
  >
    <InputPassword
      v-model="password"
      label="Senha"
      data-testid="input-password"
    />
    <template #buttons>
      <ModalButton @click="close">Cancelar</ModalButton>
      <ModalButton :disabled="isButtonConfirmDisabled" @click="submitPassword">
        Confirmar
      </ModalButton>
    </template>
  </Modal>
</template>
<script lang="ts">
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { ModalButton, Modal, InputPassword } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    Modal,
    ModalButton,
    InputPassword
  }
})
export default class PasswordModal extends Vue {
  @Prop(Boolean)
  private showModal!: boolean;

  private isButtonConfirmDisabled = true;
  private password = '';

  @Watch('password')
  private updateButtonDisabled() {
    this.isButtonConfirmDisabled = this.password === '';
  }

  private submitPassword() {
    this.submit();
  }

  @Emit()
  private submit() {
    return this.password;
  }

  @Emit()
  private close() {}
}
</script>
